function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarCancelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.55 5h-3V3h-2v2h-12V3h-2v2h-3a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7h-22V7h3v3h2V7h12v3h2V7h3v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55 27h-12V16h-2v11a2 2 0 002 2h12v-2zM16.55 22v2h-3v-2h3zM16.55 18v2h-3v-2h3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 20v-2h-4v2h4zM11.55 22v2h-4v-2h4zM20.964 19l8.486 8.485-1.415 1.415-8.485-8.486L20.964 19z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.45 20.414L20.965 28.9l-1.415-1.414L28.035 19l1.415 1.414z",
    fill: props.color
  }));
}

export default SvgIconCalendarCancelFilled;